import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { GlobalSupplierSelectorComponent } from './global-supplier-selector/global-supplier-selector.component';
import { GridSelectBoxModule } from '../components/grid-select-box/grid-select-box.module';

import { MaterialModule } from '../../material.module';

import { AddAuthToRequestsInterceptor } from '../../services/add-auth-to-requests.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  imports: [RouterModule, CommonModule, MaterialModule, GridSelectBoxModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddAuthToRequestsInterceptor,
      multi: true,
    },
  ],
  declarations: [NavbarComponent, GlobalSupplierSelectorComponent],
  exports: [NavbarComponent],
})
export class NavbarModule {}
